module.exports = __webpack_public_path__ + "static/media/up_logo_black.d199bb96.png";